import { useGlobalStore } from 'store';
import bindActions from 'store/bindActions';
import authReducer from 'store/auth';

const { actions } = authReducer;

const useAuth = () => {
	const { state, dispatch } = useGlobalStore();

	// List of Props
	const { user, error, isLoading, redirectTo, sessionChecked } = state.auth;

	// List of Actions
	const { handleLogin, handleLogout, handleMe } = actions;

	// Bind Actions
	const boundActions = bindActions(
		{
			handleLogin,
			handleLogout,
			handleMe,
		},
		dispatch
	);

	return {
		user,
		error,
		isLoading,
		redirectTo,
		sessionChecked,
		...boundActions,
	};
};

export default useAuth;
